import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Outlet } from "react-router-dom";

const NonAuthLayout = ({ children }: any) => {
    const selectLayoutState = (state: any) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutThemeType: layout.layoutThemeType,
            layoutModeType: layout.layoutModeType,
        })
    );
    // Inside your component
    const {
        layoutModeType,
        layoutThemeType,
    } = useSelector(selectLayoutProperties);
    useEffect(() => {
        document.documentElement.setAttribute("data-theme", layoutThemeType);
        if (layoutModeType === "dark") {
            document.documentElement.setAttribute("data-bs-theme", "dark");
        } else {
            document.documentElement.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.documentElement.removeAttribute("data-bs-theme");
            document.documentElement.removeAttribute("data-theme");
        };
    }, [layoutModeType,layoutThemeType]);
    return <Outlet />;
}
export default NonAuthLayout